/**
 * Quick add for ìtùnú sections: product tiles, reels and hotspots.
 *
 * Any button with data-itunu-add="<variant id>" adds one of that variant and
 * hands the result to the theme the same way its own product form does, by
 * dispatching CartLinesUpdateEvent. The cart drawer and the cart count listen
 * for that event, so the drawer opens and re-renders exactly as it would from
 * a product page. Nothing here talks to anything but the store's own cart.
 */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const ADDING = 'is-adding';

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-itunu-add]') : null;
  if (!button || button.classList.contains(ADDING)) return;
  event.preventDefault();
  const variantId = button.getAttribute('data-itunu-add');
  if (variantId) add(button, variantId, 1);
});

// The product page form still posts to /cart/add without JavaScript. With it,
// the add happens in place and the drawer opens instead of a page load.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-itunu-ajax')) return;
  const data = new FormData(form);
  const variantId = data.get('id');
  if (!variantId) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]') || form;
  add(button, String(variantId), Number(data.get('quantity')) || 1);
});

async function add(button, variantId, quantity) {
  if (button.classList.contains(ADDING)) return;

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement ? el.dataset.sectionId : '')
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity }],
      promise: deferred.promise,
    })
  );

  button.classList.add(ADDING);
  const label = button.querySelector('[data-itunu-add-label]');
  const original = label ? label.textContent : '';

  try {
    const routes = (window.Theme && window.Theme.routes) || {};
    const response = await fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity }],
        sections: sectionIds.join(','),
      }),
    }).then((r) => r.json());

    const cart = await fetch(`${routes.cart_url || '/cart'}.js`, {
      headers: { Accept: 'application/json' },
    }).then((r) => r.json());

    const didError = Boolean(response && response.status);
    if (didError) {
      button.dispatchEvent(
        new CartErrorEvent({ error: response.message || 'Add to cart failed', code: 'INVALID', detail: {} })
      );
    }

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'itunu-quick-add',
        sourceId: button.id || variantId,
        itemCount: quantity,
        productId: button.getAttribute('data-product-id') || '',
        sections: response && response.sections,
        didError,
      },
    });

    if (label && !didError) {
      label.textContent = button.getAttribute('data-added-label') || 'Added';
      setTimeout(() => { label.textContent = original; }, 1800);
    }
  } catch (error) {
    deferred.reject(error);
  } finally {
    button.classList.remove(ADDING);
  }
}
